var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Combined Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8,15.6 C14.1312,15.6 14.4,15.8688 14.4,16.2 L14.4,16.2 L14.4,17.4 C14.4,17.7312 14.1312,18 13.8,18 L13.8,18 L0.6,18 C0.2688,18 7.37188088e-13,17.7312 7.37188088e-13,17.4 L7.37188088e-13,17.4 L7.37188088e-13,16.2 C7.37188088e-13,15.8688 0.2688,15.6 0.6,15.6 L0.6,15.6 Z M7.8,7.01660952e-14 C8.1312,7.01660952e-14 8.4,0.2688 8.4,0.6 L8.4,0.6 L8.4,9.162 L10.758,7.0956 C11.0076,6.8784 11.3856,6.9024 11.604,7.1508 L11.604,7.1508 L12.3948,8.0508 C12.6144,8.2992 12.5892,8.6796 12.3396,8.898 L12.3396,8.898 L7.596,13.0512 C7.3692,13.2492 7.032,13.2492 6.8052,13.0512 L6.8052,13.0512 L2.0604,8.898 C1.8108,8.6796 1.7856,8.2992 2.0052,8.0496 L2.0052,8.0496 L2.796,7.1508 C3.0156,6.9024 3.3936,6.8784 3.642,7.0956 L3.642,7.0956 L6,9.162 L6,0.6 C6,0.2688 6.2688,7.01660952e-14 6.6,7.01660952e-14 L6.6,7.01660952e-14 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.cde43a7e.svg";
export { ForwardRef as ReactComponent };